import type { AppModule } from "../types";

const kiosks = () => import("./pages/KiosksPage").then((m) => ({ Component: m.KiosksPage }));
const activity = () => import("./pages/ActivityPage").then((m) => ({ Component: m.ActivityPage }));

export const kioskActivityModule: AppModule = {
  name: "kiosk-activity",
  routes: {
    shell: [
      { path: "/kiosks", handle: { title: "Kiosks" }, lazy: kiosks },
      { path: "/kiosks/:kioskId", handle: { title: "Kiosks" }, lazy: kiosks },
      { path: "/activity", handle: { title: "Activity" }, lazy: activity },
      { path: "/activity/screenshots", handle: { title: "Activity" }, lazy: activity },
      { path: "/activity/locations", handle: { title: "Activity" }, lazy: activity },
      { path: "/activity/kiosk-photos", handle: { title: "Activity" }, lazy: activity },
      {
        path: "/activity-monitoring",
        handle: { title: "Activity-monitoring" },
        lazy: () => import("./pages/MonitoringPage").then((m) => ({ Component: m.MonitoringPage })),
      },
    ],
    // Outside AuthGate: the device has a kiosk cookie, not a web session.
    kiosk: [
      {
        path: "/kiosk/:kioskId",
        handle: { title: "Kiosk" },
        lazy: () => import("./pages/KioskApp").then((m) => ({ Component: m.KioskApp })),
      },
    ],
  },
};
